import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withCmsForm from 'modules/common/hoc/withCmsForm';
import * as actions from '../action';
import * as c from '../constant';

const CMS_TYPE = 'COLORS';

const fields = [
  'primary_color',
  'primary_color_light',
  'secondary_color',
  'warning_color',
  'danger_color',
  'muted_color',
  'muted_color_secondary',
  'glow_color',
  'light_color',
];

const fieldConfig = [
  { key: 'primary_color', label: 'Primary Color:' },
  { key: 'primary_color_light', label: 'Primary Color Light:' },
  { key: 'secondary_color', label: 'Secondary Color:' },
  { key: 'warning_color', label: 'Warning Color:' },
  { key: 'danger_color', label: 'Danger Color:' },
  { key: 'muted_color', label: 'Muted Color:' },
  { key: 'muted_color_secondary', label: 'Muted Secondary Color:' },
  { key: 'glow_color', label: 'Glow Color:' },
  { key: 'light_color', label: 'Light Color:' },
];

function Colors({
  getList,
  createInput,
  item,
  setFormData,
  createHidden,
  create,
  update,
  formData,
}) {
  useEffect(() => {
    getList({ type: CMS_TYPE });
  }, []);

  useEffect(() => {
    setFormData({
      ...JSON.parse(_.get(item, 'attributes.body') || '{}'),
      id: _.get(item, 'id'),
    });
  }, [item]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (_.get(formData, 'id')) {
      return update(_.get(formData, 'id'), {
        body: JSON.stringify(_.pick(formData, fields)),
      });
    }

    return create({
      body: JSON.stringify(_.pick(formData, fields)),
    });
  };

  return (
    <div className="card border-0 shadow-sm">
      <div className="card-body p-4 p-lg-5">
        <form onSubmit={handleOnSubmit}>
          {createHidden({ key: 'id' }, { placeholder: '' })}
          <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-3">
            <div>
              <h5 className="mb-1 font-weight-bold">Color Palette</h5>
              <p className="mb-0 text-muted">
                Configure brand and system colors layout.
              </p>  
            </div>
          </div>
          <div className="row">
            {fieldConfig.map(({ key, label }) => (
              <div key={key} className="col-12 col-md-6 col-lg-4 mb-3">
                <div className="p-3 border rounded bg-white shadow-sm h-100">
                  <div className="form-group mb-0">
                    {createInput(
                      { key, label }, 
                      { required: true, type: 'color' },
                      'input-cms-color form-control border rounded'
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="d-flex justify-content-center pt-2">
            <button
              // disabled={creating}
              type="submit"
              className="btn btn-primary cms-bg-color-primary cms-outline-primary px-4 font-weight-bold"
            >
              {/* {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`} */}
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

Colors.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createHidden: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  create: PropTypes.instanceOf(Function).isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: (_.get(api, `${c.GET_SETTINGS}.list`) || [])[0] || {},
});

const enhance = _.flowRight([
  withCmsForm,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(Colors);
